'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reduxForm = require('redux-form');

var _zendesk = require('../../redux/modules/zendesk');

var _reportAssetFormValidation = require('../../utils/reportAssetFormValidation');

var _reportAssetFormValidation2 = _interopRequireDefault(_reportAssetFormValidation);

var _ReportAssetPopup = require('@quixeltools/quixel-ui-library/dist/components/megascans/library/ReportAssetPopup');

var _ReportAssetPopup2 = _interopRequireDefault(_ReportAssetPopup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReportAssetPopupContainer = (_dec = (0, _reduxForm.reduxForm)({
  form: 'reportAsset',
  fields: ['comments'],
  validate: _reportAssetFormValidation2.default
}), _dec2 = (0, _reactRedux.connect)(null, { createTicket: _zendesk.createTicket }), _dec(_class = _dec2(_class = function (_React$Component) {
  (0, _inherits3.default)(ReportAssetPopupContainer, _React$Component);

  function ReportAssetPopupContainer(props) {
    (0, _classCallCheck3.default)(this, ReportAssetPopupContainer);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ReportAssetPopupContainer.__proto__ || (0, _getPrototypeOf2.default)(ReportAssetPopupContainer)).call(this, props));

    _this.state = {
      message: null,
      error: null
    };

    _this.onSubmitClick = _this.onSubmitClick.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(ReportAssetPopupContainer, [{
    key: 'onSubmitClick',
    value: function onSubmitClick(values) {
      var _this2 = this;

      this.setState({
        message: null,
        error: null
      });

      var comments = values.comments;


      var tag = this.props.is3d ? '3dAssetReport' : '2dAssetReport';
      var email = this.props.email;
      var name = this.props.is3d ? '3d Asset Report' : '2d Asset Report';
      var subject = (this.props.is3d ? '3d' : '2d') + 'Asset Reported ' + this.props.assetId;
      var comment = comments + '\nhttps://quixel.com/assets/' + this.props.assetId + '\n\nReported By: ' + email;

      var custom_fields = [{
        id: '360000990877',
        value: this.props.is3d ? '3dAsset_Report' : '2dAsset_Report'
      }];

      return this.props.createTicket({ email: 'reports@quixel.se', comment: comment, tag: tag, name: name, subject: subject, custom_fields: custom_fields }).then(function () {
        _this2.setState({
          message: 'Thank you! We have your feedback. We\'ll take a look shortly!'
        });
      }, function (reason) {
        _this2.setState({
          error: reason.message
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          commentsInputProps = _props.fields.comments,
          handleSubmit = _props.handleSubmit,
          submitting = _props.submitting,
          tag = _props.tag,
          childReference = _props.childReference;


      return _react2.default.createElement(_ReportAssetPopup2.default, {
        icon: '/quixel_2080_logo.png',
        title: 'Report Asset',
        description: 'Please describe the issue you encountered below.',

        commentsInputProps: commentsInputProps,

        error: this.state.error,
        message: this.state.message,
        submitting: submitting,
        onSubmit: handleSubmit(this.onSubmitClick),

        tag: tag,
        onChildRef: childReference
      });
    }
  }]);
  return ReportAssetPopupContainer;
}(_react2.default.Component)) || _class) || _class);
exports.default = ReportAssetPopupContainer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ReportAssetContainer/ReportAssetContainer.jsx
// module id = 2787
// module chunks = 0